import axios from "axios";
import { Config } from "../Config";
import { userAccessToken } from "../helpers";

export const fetchMessage = async (filter, account_id, location_id) => {
  const { page, per_page, search_term, status, message_type, order_by } = filter;

  try {
    const searchParam = search_term ? `&search_term=${search_term}` : "";
    const sStatus = status ? `&status=${status}` : "";
    const messageType = message_type ? `&message_type=${message_type}` : "";
    let orderBy = order_by ? `&order_by=${JSON.stringify(order_by)}` : "";
    const response = await axios.get(
      `${Config.notificationServerUrl}/message-transaction/all?account_id=${account_id}&location_id=${location_id}&page=${page}&per_page=${per_page}${searchParam}${sStatus}${messageType}${orderBy}`,
      {
        headers: {
          "Content-Type": "application/json",
          accept: "application/json",
          Authorization: `Bearer ${userAccessToken()}`,
        },
      }
    );
    return response;
  } catch (error) {}
};

export const submitBulkMessage = async (formData, account_id, location_id) => {
  try {
    const response = await axios.post(
      `${Config.notificationServerUrl}/message-transaction/create-bulk?account_id=${account_id}&location_id=${location_id}`,
      formData,
      {
        headers: {
          "Content-Type": "application/json",
          accept: "application/json",
          Authorization: `Bearer ${userAccessToken()}`,
        },
      }
    );
    return response;
  } catch (error) {
    return error?.response?.data;
  }
};


export const fetchMessageTemplate = async (filter, account_id) => {
  const { page, per_page, search_term, template_type, title, order_by } = filter;

  try {
    const searchParam = search_term ? `&search_term=${search_term}` : "";
    const templateType = template_type ? `&template_type=${template_type}` : "";
    const templateTitle = title ? `&title=${title}` : "";
    let orderBy = order_by ? `&order_by=${JSON.stringify(order_by)}` : "";
    const response = await axios.get(
      `${Config.notificationServerUrl}/message-transaction/get-template?account_id=${account_id}&page=${page}&per_page=${per_page}${searchParam}${templateType}${templateTitle}${orderBy}`,
      {
        headers: {
          "Content-Type": "application/json",
          accept: "application/json",
          Authorization: `Bearer ${userAccessToken()}`,
        },
      }
    );
    return response;
  } catch (error) {}
};

// for dropdown only
export const loadMessageTemplate = async (account_id, type='') => {
  try {
    const searchParam = type ? `&search_term=${type}` : "";
    const response = await axios.get(
      `${Config.notificationServerUrl}/message-transaction/get-template?account_id=${account_id}&page=1&per_page=200${searchParam}`,
      {
        headers: {
          "Content-Type": "application/json",
          accept: "application/json",
          Authorization: `Bearer ${userAccessToken()}`,
        },
      }
    );
    return response;
  } catch (error) {}
};

export const loadGenerateTemplate = async (account_id, location_id) => {
  try {
    const response = await axios.get(
      `${Config.notificationServerUrl}/message-transaction/generate-template?account_id=${account_id}&location_id=${location_id}`,
      {
        headers: {
          "Content-Type": "application/json",
          accept: "application/json",
          Authorization: `Bearer ${userAccessToken()}`,
        },
      }
    );
    return response;
  } catch (error) {
    return error?.response?.data;
  }
};

export const getSMSLimitData = async (account_id) => {
  try {
    const response = await axios.get(
      `${Config.notificationServerUrl}/account-message-config/get-by-account-id?account_id=${account_id}`,
      {
        headers: {
          "Content-Type": "application/json",
          accept: "application/json",
          Authorization: `Bearer ${userAccessToken()}`,
        },
      }
    );
    return response;
  } catch (error) {
    return error?.response?.data;
  }
};

export const setDummySMS = async (data) => {
  try {
    const response = axios.put(`${Config.notificationServerUrl}/account-message-config/dummy-sms`, data,
      {
        headers: {
          "Content-Type": "application/json",
          accept: "application/json",
          Authorization: `Bearer ${userAccessToken()}`,
        },
      }
    );
    return response;

  } catch (error) {
    return error?.response?.data;
  }
};

export const setSMSCredit = async (data) => {
  try {
    const response = await axios.post(`${Config.notificationServerUrl}/account-message-config/add-credit`, data,
      {
        headers: {
          "Content-Type": "application/json",
          accept: "application/json",
          Authorization: `Bearer ${userAccessToken()}`,
        },
      }
    );
    return response;
  } catch (error) {
    return error?.response?.data;
  }
};

export const retrySendBulkMessage = async (formData) => {
  try {
    const response = await axios.post(
      `${Config.notificationServerUrl}/message-transaction/retry-send-bulk`, formData,
      {
        headers: {
          "Content-Type": "application/json",
          accept: "application/json",
          Authorization: `Bearer ${userAccessToken()}`,
        },
      }
    );
    return response;
  } catch (error) {
    return error?.response?.data;
  }
};

export const setDummyCall = async (data) => {
  try {
    const response = axios.put(`${Config.notificationServerUrl}/account-message-config/dummy-call`, data,
      {
        headers: {
          "Content-Type": "application/json",
          accept: "application/json",
          Authorization: `Bearer ${userAccessToken()}`,
        },
      }
    );
    return response;

  } catch (error) {
    return error?.response?.data;
  }
};

export const uploadSmsFile = async (data) => {
  try {
    const formData = new FormData();
    Object.keys(data).forEach((key) => {
      formData.append(key, data[key]);
    });

    const response = await axios.post(
      `${Config.apiServerUrl}/mips/bulk-upload-sms-file`,
      formData,
      {
        headers: {
          "Content-Type": "multipart/form-data",
          Authorization: `Bearer ${userAccessToken()}`,
        },
      }
    );
    return response;
  } catch (error) {
    return error?.response?.data;
  }
};